import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fdb3008"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "rte-toolbar",
  role: "toolbar",
  "aria-label": "Textformatierung"
}
const _hoisted_2 = ["value"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<option value=\"paragraph\" data-v-2fdb3008>Fließtext</option><option value=\"h1\" data-v-2fdb3008>Überschrift 1</option><option value=\"h2\" data-v-2fdb3008>Überschrift 2</option><option value=\"h3\" data-v-2fdb3008>Überschrift 3</option><option value=\"blockquote\" data-v-2fdb3008>Hinweis</option>", 5)
const _hoisted_8 = [
  _hoisted_3
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rte-sep",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "F", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "K", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rte-sep",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<svg width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-2fdb3008><line x1=\"9\" y1=\"6\" x2=\"20\" y2=\"6\" data-v-2fdb3008></line><line x1=\"9\" y1=\"12\" x2=\"20\" y2=\"12\" data-v-2fdb3008></line><line x1=\"9\" y1=\"18\" x2=\"20\" y2=\"18\" data-v-2fdb3008></line><circle cx=\"4.5\" cy=\"6\" r=\"1.3\" fill=\"currentColor\" stroke=\"none\" data-v-2fdb3008></circle><circle cx=\"4.5\" cy=\"12\" r=\"1.3\" fill=\"currentColor\" stroke=\"none\" data-v-2fdb3008></circle><circle cx=\"4.5\" cy=\"18\" r=\"1.3\" fill=\"currentColor\" stroke=\"none\" data-v-2fdb3008></circle></svg>", 1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<svg width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-2fdb3008><line x1=\"10\" y1=\"6\" x2=\"20\" y2=\"6\" data-v-2fdb3008></line><line x1=\"10\" y1=\"12\" x2=\"20\" y2=\"12\" data-v-2fdb3008></line><line x1=\"10\" y1=\"18\" x2=\"20\" y2=\"18\" data-v-2fdb3008></line><text x=\"2\" y=\"8\" font-size=\"7\" fill=\"currentColor\" stroke=\"none\" data-v-2fdb3008>1</text><text x=\"2\" y=\"14.5\" font-size=\"7\" fill=\"currentColor\" stroke=\"none\" data-v-2fdb3008>2</text><text x=\"2\" y=\"21\" font-size=\"7\" fill=\"currentColor\" stroke=\"none\" data-v-2fdb3008>3</text></svg>", 1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rte-sep",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<svg width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" data-v-2fdb3008><rect x=\"3\" y=\"4\" width=\"18\" height=\"16\" rx=\"1.5\" data-v-2fdb3008></rect><line x1=\"3\" y1=\"9\" x2=\"21\" y2=\"9\" data-v-2fdb3008></line><line x1=\"9\" y1=\"9\" x2=\"9\" y2=\"20\" data-v-2fdb3008></line><line x1=\"15\" y1=\"9\" x2=\"15\" y2=\"20\" data-v-2fdb3008></line></svg>", 1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.5 1.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.5-1.5" })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "4",
    y1: "12",
    x2: "20",
    y2: "12"
  })
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rte-sep",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 7v6h6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3.5 13a9 9 0 1 0 2.1-9.4L3 7" })
], -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21 7v6h-6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M20.5 13a9 9 0 1 1-2.1-9.4L21 7" })
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rte-sep",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Platzhalter …", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "einrichtung" }, "Name der Einrichtung", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "datum" }, "Aktuelles Datum", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "feld" }, "Feld zum Ausfüllen", -1))
const _hoisted_36 = [
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "rte-tablebar"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rte-tablebar-label" }, "Tabelle:", -1))

import { ref, reactive, watch, onBeforeUnmount, withDefaults } from 'vue';
import { useEditor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';


export default /*#__PURE__*/_defineComponent({
  __name: 'RichTextEditor',
  props: {
    modelValue: null,
    ariaLabel: { default: 'Dokumentinhalt' },
    placeholders: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:modelValue', value: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string, ariaLabel: string, placeholders: boolean }





const focused = ref(false);

// Zustand der Werkzeugleiste; wird bei jeder Auswahl-/Inhaltsänderung nachgeführt.
const state = reactive({
  block: 'paragraph',
  bold: false,
  italic: false,
  bulletList: false,
  orderedList: false,
  link: false,
  table: false,
});

const editor = useEditor({
  content: props.modelValue || '',
  extensions: [
    // Nur Formate zulassen, die das Dokumentformat kennt: Durchstreichen und
    // Code-Blöcke ließen sich beim Speichern nicht abbilden.
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
      strike: false,
      code: false,
      codeBlock: false,
    }),
    Link.configure({ openOnClick: false, autolink: true }),
    Table.configure({ resizable: false }),
    TableRow,
    TableHeader,
    TableCell,
  ],
  editorProps: {
    attributes: {
      class: 'rte-body md-doc',
      role: 'textbox',
      'aria-multiline': 'true',
      'aria-label': props.ariaLabel,
    },
  },
  onUpdate: ({ editor: instance }) => {
    emit('update:modelValue', instance.getHTML());
    syncState();
  },
  onSelectionUpdate: syncState,
  onFocus: () => { focused.value = true; },
  onBlur: () => { focused.value = false; },
});

function syncState() {
  const instance = editor.value;
  if (!instance) return;
  state.bold = instance.isActive('bold');
  state.italic = instance.isActive('italic');
  state.bulletList = instance.isActive('bulletList');
  state.orderedList = instance.isActive('orderedList');
  state.link = instance.isActive('link');
  state.table = instance.isActive('table');
  if (instance.isActive('heading', { level: 1 })) state.block = 'h1';
  else if (instance.isActive('heading', { level: 2 })) state.block = 'h2';
  else if (instance.isActive('heading', { level: 3 })) state.block = 'h3';
  else if (instance.isActive('blockquote')) state.block = 'blockquote';
  else state.block = 'paragraph';
}

// Inhalt von außen übernehmen (z. B. nachgeladenes Dokument), ohne die
// Cursorposition beim Tippen zu verlieren.
watch(() => props.modelValue, (value) => {
  const instance = editor.value;
  if (instance && value !== instance.getHTML()) {
    instance.commands.setContent(value || '', false);
    // Nach dem Laden oben beginnen; sonst stünde die Auswahl am Dokumentende
    // und die Werkzeugleiste zeigte den Zustand der letzten Zeile an.
    instance.commands.setTextSelection(1);
    syncState();
  }
});

/* eslint-disable @typescript-eslint/no-explicit-any */
function run(action: (chain: any) => any) {
  const instance = editor.value;
  if (!instance) return;
  action(instance.chain().focus()).run();
  syncState();
}
/* eslint-enable @typescript-eslint/no-explicit-any */

function setBlock(value: string) {
  const instance = editor.value;
  if (!instance) return;
  const chain = instance.chain().focus();
  // Ein Hinweis-Block ist ein Zitat um Fließtext; beim Wechsel wird er aufgelöst.
  if (instance.isActive('blockquote') && value !== 'blockquote') chain.liftBlockquote();
  if (value === 'paragraph') chain.setParagraph();
  else if (value === 'blockquote') chain.setParagraph().setBlockquote();
  else chain.setHeading({ level: Number(value.slice(1)) as 1 | 2 | 3 });
  chain.run();
  syncState();
}

function insertTable() {
  run((c) => c.insertTable({ rows: 3, cols: 2, withHeaderRow: true }));
}

function toggleLink() {
  const instance = editor.value;
  if (!instance) return;
  if (instance.isActive('link')) {
    run((c) => c.unsetLink());
    return;
  }
  const url = window.prompt('Adresse des Links (z. B. https://…)');
  if (!url) return;
  run((c) => c.setLink({ href: url }));
}

function insertPlaceholder(event: Event) {
  const select = event.target as HTMLSelectElement;
  const key = select.value;
  select.value = '';
  if (!key) return;
  run((c) => c.insertContent(`{{${key}}}`));
}

onBeforeUnmount(() => {
  if (editor.value) editor.value.destroy();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rte", { focused: focused.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("select", {
        class: "rte-select",
        "aria-label": "Absatzformat",
        value: state.block,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (setBlock(($event.target as HTMLSelectElement).value)))
      }, _hoisted_8, 40, _hoisted_2),
      _hoisted_9,
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["rte-btn", { active: state.bold }]),
        title: "Fett (Strg+B)",
        "aria-label": "Fett",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (run((c) => c.toggleBold())))
      }, _hoisted_11, 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["rte-btn", { active: state.italic }]),
        title: "Kursiv (Strg+I)",
        "aria-label": "Kursiv",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (run((c) => c.toggleItalic())))
      }, _hoisted_13, 2),
      _hoisted_14,
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["rte-btn", { active: state.bulletList }]),
        title: "Aufzählung",
        "aria-label": "Aufzählung",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (run((c) => c.toggleBulletList())))
      }, _hoisted_16, 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["rte-btn", { active: state.orderedList }]),
        title: "Nummerierte Liste",
        "aria-label": "Nummerierte Liste",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (run((c) => c.toggleOrderedList())))
      }, _hoisted_18, 2),
      _hoisted_19,
      _createElementVNode("button", {
        type: "button",
        class: "rte-btn",
        title: "Tabelle einfügen",
        "aria-label": "Tabelle einfügen",
        onClick: insertTable
      }, _hoisted_21),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["rte-btn", { active: state.link }]),
        title: "Link einfügen",
        "aria-label": "Link einfügen",
        onClick: toggleLink
      }, _hoisted_23, 2),
      _createElementVNode("button", {
        type: "button",
        class: "rte-btn",
        title: "Trennlinie",
        "aria-label": "Trennlinie",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (run((c) => c.setHorizontalRule())))
      }, _hoisted_25),
      _hoisted_26,
      _createElementVNode("button", {
        type: "button",
        class: "rte-btn",
        title: "Rückgängig (Strg+Z)",
        "aria-label": "Rückgängig",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (run((c) => c.undo())))
      }, _hoisted_28),
      _createElementVNode("button", {
        type: "button",
        class: "rte-btn",
        title: "Wiederholen (Strg+Umschalt+Z)",
        "aria-label": "Wiederholen",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (run((c) => c.redo())))
      }, _hoisted_30),
      (__props.placeholders)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_31,
            _createElementVNode("select", {
              class: "rte-select",
              "aria-label": "Platzhalter einfügen",
              value: "",
              onChange: _cache[8] || (_cache[8] = ($event: any) => (insertPlaceholder($event)))
            }, _hoisted_36, 32)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (state.table)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("button", {
            type: "button",
            class: "rte-mini",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (run((c) => c.addRowAfter())))
          }, "+ Zeile"),
          _createElementVNode("button", {
            type: "button",
            class: "rte-mini",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (run((c) => c.addColumnAfter())))
          }, "+ Spalte"),
          _createElementVNode("button", {
            type: "button",
            class: "rte-mini danger",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (run((c) => c.deleteRow())))
          }, "− Zeile"),
          _createElementVNode("button", {
            type: "button",
            class: "rte-mini danger",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (run((c) => c.deleteColumn())))
          }, "− Spalte"),
          _createElementVNode("button", {
            type: "button",
            class: "rte-mini danger",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (run((c) => c.deleteTable())))
          }, "Tabelle löschen")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(EditorContent), {
      editor: _unref(editor),
      class: "rte-content"
    }, null, 8, ["editor"])
  ], 2))
}
}

})